import { Point } from 'paper';

export const strokeColor = '#ff1616';
export const strokeWidth = 3;
export const opacity = 0.7;
export const strokeCap = 'round';
export const shadowColor = '#ff4747';
export const shadowBlur = 8;
export const shadowOffset = new Point(2, 2);
export const disappearTimeout = 500;
